import { ErrorBoundary } from 'react-error-boundary';
import PropTypes from 'prop-types';
import ErrorBoundaryFallback from '@components/ErrorBoundaryWrapper/ErrorBoundaryFallback';

const ErrorBoundaryWrapper = ({
  children = null,
  customFallbackComponent: CustomFallbackComponent = null,
  baseFallbackSx = {},
  name = '',
}) => {
  const isProd = import.meta.env.VITE_ENV_NAME === 'prod';

  const handleErrorBoundaryLogging = (error, info) => {
    if (!isProd) {
      console.error('An error occurred while loading your application: ', name, {
        name: error?.name,
        message: error?.message,
        stack: error?.stack,
      });
      console.info('Component Stack: ', info?.componentStack);
    } else {
      console.error('An error occurred while loading your application.');
    }
  };

  const BaseErrorBoundaryFallback = () => <ErrorBoundaryFallback fallbackSx={baseFallbackSx} />;

  return (
    <ErrorBoundary
      FallbackComponent={CustomFallbackComponent ?? BaseErrorBoundaryFallback}
      onError={handleErrorBoundaryLogging}
    >
      {children}
    </ErrorBoundary>
  );
};

ErrorBoundaryWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  customFallbackComponent: PropTypes.elementType,
  baseFallbackSx: PropTypes.shape({
    wrapperSx: PropTypes.object,
  }),
  name: PropTypes.string.isRequired,
};

export default ErrorBoundaryWrapper;
